import React from "react";
import { getBodyData, getHeadData } from "utils/productHelpers";
import { TableCard } from "components/InputCards/TableCard";
import { ExpandableSection } from "components/ProductConfigurator/components/Results/components/ExpandableSection";
import { useProductOutput } from "stores/product";
import cx from "classnames";
import styles from "../../ProductConfigurationResultMainView.module.scss";
import { useTranslate } from "hooks";

export const AcousticResults = () => {
  const productOutput = useProductOutput();
  const translate = useTranslate();
  const outputsAcoustic = productOutput?.product?.outputsAcoustic ?? [];
  return (
    outputsAcoustic.length > 0 && (
      <ExpandableSection
        title={translate(
          "PRODUCT_CONFIGURATOR_REPORT_ACOUSTING_LABEL",
        ).toString()}
        classNames={cx(
          styles.acousticCell,
          "border rounded p-1 m-2" +
            " m-xxl-3 mt-xxl-0 p-xxl-2" +
            " m-xxxl-4 mt-xxxl-2 p-xxxl-3",
        )}
        viewWithTable={true}
      >
        <div className="overflow-auto w-100 mt-3">
          <TableCard
            head={getHeadData(outputsAcoustic)}
            body={getBodyData(outputsAcoustic)}
            classNames="w-100"
            headerTitle={
              <th>
                {translate("PRODUCT_CONFIGURATOR_REPORT_ACOUSTING_LABEL")}
              </th>
            }
          />
        </div>
      </ExpandableSection>
    )
  );
};
